
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CardDoc"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticket_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"card_group_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aliases"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"issuer_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"card_level_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"launch_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"effective_date_b"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"effective_date_e"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"function_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apply_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apply_condition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apply_doc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"income_threshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fee_1st_l"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fee_1st_h"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fee_1st_note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fee_2nd_l"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fee_2nd_h"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fee_2nd_note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apply_process"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"suspend_process"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rir_date_b"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rir"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overdue_fine"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cash_adv_fee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"foreign_trans_fee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"report_loss_fee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"report_loss_charge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"review_slip_fee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rebill_fee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zero_interest_installments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_installment_money"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cash_adv_interest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cash_adv_prepayment_penalty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birth_present"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birth_present_detail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user_guide"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ratable_filter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scope_filter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"who"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"img_urls"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":746}};
    doc.loc.source = {"body":"fragment CardFull on CardDoc {\n  _id\n  ticket_id\n  card_group_id\n  aliases\n  issuer_id\n  card_level_id\n  launch_date\n  effective_date_b\n  effective_date_e\n  function_ids\n  apply_url\n  apply_condition\n  apply_doc\n  income_threshold\n  fee_1st_l\n  fee_1st_h\n  fee_1st_note\n  fee_2nd_l\n  fee_2nd_h\n  fee_2nd_note\n  apply_process\n  suspend_process\n  rir_date_b\n  rir\n  overdue_fine\n  cash_adv_fee\n  foreign_trans_fee\n  report_loss_fee\n  report_loss_charge\n  review_slip_fee\n  rebill_fee\n  zero_interest_installments\n  min_installment_money\n  cash_adv_interest\n  cash_adv_prepayment_penalty\n  birth_present\n  birth_present_detail\n  user_guide\n  enabled\n  uploader\n  ratable_filter\n  scope_filter\n  who\n  attributes {\n    key\n    value\n  }\n  img_urls\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CardFull"] = oneQuery(doc, "CardFull");
        
